













import { Component, Vue } from 'vue-property-decorator'
import store from '@/store'
import { Route } from 'vue-router'
import { NextFunction } from 'express'
import TestDetailsLegacy from '../components/TestDetailsLegacy.vue'
import DefaultDraftState from '../components/DefaultDraftState.vue'
import { User } from '@/types/frontend'

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate'
])

// Can't be a function inside the component since it doesn't exist yet when
// beforeRouteEnter is called
async function preLoadTestData (workspaceId: string, testId: string) {
  const test = await store.dispatch.workspace.loadTest({ workspaceId, testId })
  if (!test) {
    store.dispatch.setErrorMessage({
      header: 'Page unavailable',
      body: 'Test could not be found.'
    })
    return
  }

  return {
    followers: test.followers,
    users: test.allUsers,
    loadNewTestExperience: shouldLoadNewTestExperience()
  }
}

function shouldLoadNewTestExperience () {
  const params = new URLSearchParams(window.location.search)
  const dd = params.get('dd')
  if (dd === 'true') return true
  if (dd === 'false') return false
  return !!store.getters.feature.hasFeature('newTestExperience')
}

@Component({
  components: {
    TestDetailsLegacy,
    DefaultDraftState
  }
})
export default class TestDetails extends Vue {
  // Tried this as a get method reading from the store, but had issues
  // when you change routes it pre-fetches the new feature config and would show
  // a different version of the page for a split second before routing
  loadNewTestExperience = false
  users: User[] = []
  followers: User[] = []

  async beforeRouteEnter (to: Route, from: Route, next: NextFunction) {
    const { workspaceId, testId } = to.params
    const result = await preLoadTestData(workspaceId, testId)

    if (result) {
      next((vm: TestDetails) => {
        vm.followers = result.followers
        vm.users = result.users
        vm.loadNewTestExperience = result.loadNewTestExperience
      })
    } else {
      next()
    }
  }

  async beforeRouteUpdate (to: Route, from: Route, next: NextFunction) {
    const { workspaceId, testId } = to.params
    const result = await preLoadTestData(workspaceId, testId)

    if (result) {
      this.followers = result.followers
      this.users = result.users
      this.loadNewTestExperience = result.loadNewTestExperience
    }

    next()
  }
}
